<template>
<!-- 英文环境下不应该出现lanlabel为2（中文）的直播 -->
 <!--
  @todo 2.22需求后全是英文的。返回列表不需要前端做处理。
   v-if="en && item.liveHostInfo.lanLabel!=2 || !en" 
  -->
  <div class="video-card global_pointer" @click="gotoRoom(item.id)">
    <div class="top">
      <div class="left">
        <img
          :src="item.liveHostInfo.headImg.url"
          alt=""
        />
        <span>{{item.liveHostInfo.userName}}</span>
      </div>
      <!-- <div class="right">
        <img :src="location" alt="" />
        <span>{{item.store.cityName}}</span>
      </div> -->
    </div>
    <div class="title">{{item.liveName}}</div>
    <div class="poster">
      <img
        v-lazy="item.liveImg && item.liveImg.url || item.image.url"
        :alt="item.liveName"
      />
      <div :class="`mark ${item.liveStatus.code === 1 ? 'upcoming' : ''}`">
        <span v-if="item.liveStatus.code === 2"></span>
        {{$t('message.home.mark.'+liveStatusType)}}
      </div>
    </div>
    <div class="time">{{ dataTimeFormat(item.startTime || item.bookStartTime) }}</div>
  </div>
</template>
<style lang="less" scoped>
.video-card {
  width: 351px;
  box-sizing: border-box;
  margin: 0 auto 12px;
  padding: 12px;
  background: #1d1d1d;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  user-select: none;
  & .top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    & .left {
      line-height: 0;
      display: flex;
      align-items: center;
      & span {
        height: 20px;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.9);
        line-height: 20px;
      }
      & img {
        width: 36px;
        height: 36px;
        margin-right: 6px;
        border-radius: 36px;
      }
    }
    & .right {
      display: flex;
      align-items: center;
      & span {
        height: 16px;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);
        line-height: 16px;
      }
      & img {
        width: 12px;
        height: 12px;
        margin-right: 2px;
      }
    }
  }
  & .title {
    width: 100%;
    height: 21px;
    font-size: 18px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    line-height: 21px;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: 'Approach-SemiBold';
  }
  & .poster {
    width: 100%;
    border-radius: 8px;
    margin: 14px 0 12px;
    overflow: hidden;
    font-size: 0;
    padding: 0;
    line-height: 0;
    position: relative;
    & > img {
      width: 100%;
      pointer-events: none;
      user-select: none;
    }
    & .mark{
      position: absolute;
      top: 12px;
      left: 11px;
      // width: 44px;
      padding: 0 8px;
      height: 16px;
      line-height: 16px;
      font-size: 11px;
      background: #000000;
      border-radius: 8px;
      font-weight: bold;
      color: #39D2D6;
      display: flex;
      justify-content: center;
      align-items: center;
      & span{
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #F66355;
        border-radius: 6px;
        margin-right: 2px;
      }
    }
    & .upcoming{
      height: 19px;
      line-height: 19px;
      font-size: 12px;
      background: #086EFF;
      border-radius: 4px;
      color: #ffffff;
    }
  }
  & .time {
    height: 20px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 20px;
    text-align: left;
  }
}
</style>
<script>
import location from '@/assets/imgs/Home/icon-location.png';
import { Tabs } from '@/config/tabs';

export default {
  name: 'Card',
  props: ['currentTab', 'item'],
  data() {
    return {
      location,
      Tabs,
      en: this.$i18n.locale === 'en',
    };
  },
  computed: {
    liveStatusType() {
      const statusMap = { 1: 'Upcoming', 2: 'Live', 4: 'Replay' };
      return statusMap[this.item.liveStatus.code];
    },
  },
  inject: ['gotoRoom'],
  methods: {
    dataTimeFormat(timestemp) {
      return this.en ? this.$moment(new Date(timestemp)).format('MMMM D, yyyy | h:mmA') : this.$moment(new Date(timestemp)).format('yyyy-MM-DD h:mma');
    },
    // gotoRoom() {
    //   const path = `../room/${this.item.id}`;
    //   this.$store.commit("home/updateLastId", this.item.id);
    //   const { scrollTop, scrollLeft } = this.$refs["vs"].getPosition()
    //   console.log('scrollTop:::', scrollTop)
    //   this.$router.push(path);
    // }
  },
};
</script>
